module.exports = __webpack_public_path__ + "static/media/credit-card.d066b219.svg";